import { render, staticRenderFns } from "./DatavMap.vue?vue&type=template&id=14896cca&"
import script from "./DatavMap.vue?vue&type=script&lang=js&"
export * from "./DatavMap.vue?vue&type=script&lang=js&"
import style0 from "./DatavMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DatavMap.vue"
export default component.exports